import styled from 'styled-components'

import { H2 } from 'components'
import { Content, Panel } from 'containers/public-listing/styled'

export const LocationPanelSubject = styled(H2)`
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
`

export const LocationPanel = styled(Panel)`
  width: 267px;
`

export const LocationMap = styled(Panel)`
  position: relative;
  max-width: inherit;
  height: 100%;
`

export const LocationContent = styled(Content)`
  height: 423px;

  ${LocationMap} {
    flex-grow: 1;
  }

  ${LocationPanel} {
    width: 296px;
    height: 100%;
    margin-left: 24px;
  }

  @media (max-width: 991px) {
    height: auto;

    ${LocationMap} {
      height: 350px;
      margin-bottom: 20px;
    }

    ${LocationPanel} {
      width: 100%;
      height: 250px;
      padding: 0;
      margin-left: 0;
    }
  }
`
